export const BasicContactFields = [
  {
    fieldId: "firstName",
    fieldLabel: "Contact First Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 1,
    isValid: true,
    toolTipId: "ContactFirstName",
    toolTipText: "First Name",
    automationId: "firstName",
    placeHolder: "Terrence",
  },
  {
    fieldId: "lastName",
    fieldLabel: "Last Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 2,
    isValid: true,
    toolTipId: "lastName",
    toolTipText: "Last Name",
    placeHolder: "Buick",
    automationId: "lastName",
  },
  {
    fieldId: "email",
    fieldLabel: "Email",
    required: true,
    length: 3,
    validateType: "email",
    validateIndex: 3,
    isValid: true,
    toolTipId: "email",
    toolTipText: "Email",
    fieldType: "text",
    placeHolder: "terrence.rim@mail.com",
    automationId: "email",
  },
  {
    fieldId: "phoneNumber",
    fieldLabel: "Phone Number",
    required: true,
    length: 2,
    validateType: "phone",
    validateIndex: 4,
    isValid: true,
    toolTipId: "phoneNumber",
    toolTipText: "Phone Number",
    fieldType: "text",
    placeHolder: "(123) 456-7890",
    automationId: "phoneNumber",
  },
  {
    fieldId: "extension",
    fieldLabel: "Extension",
    fieldType: "text",
    validateType: "extension",
    validateIndex: 5,
    length: 1,
    isValid: true,
    toolTipId: "extension",
    toolTipText: "Extension",
    placeHolder: "12345",
    automationId: "extension",
  },
  {
    fieldId: "sameContact",
    fieldLabel: "Your Primary contact is same for ",
    fieldType: "checkbox",
    fieldTechnical: "Technical Contact",
    automationId: "sameContact",
  },
];

//PRIMARY CONTACT FIELDS
export const PrimaryBasicContactFields = [
  {
    fieldId: "firstName",
    fieldLabel: "Primary Contact First Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 1,
    isValid: true,
    toolTipId: "ContactFirstName",
    toolTipText: "First Name",
    automationId: "primaryFirstName",
    placeHolder: "Terrence",
  },
  {
    fieldId: "lastName",
    fieldLabel: "Last Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 2,
    isValid: true,
    toolTipId: "lastName",
    toolTipText: "Last Name",
    placeHolder: "Buick",
    automationId: "primaryLastName",
  },
  {
    fieldId: "email",
    fieldLabel: "Email",
    required: true,
    length: 3,
    validateType: "email",
    validateIndex: 3,
    isValid: true,
    toolTipId: "email",
    toolTipText: "Email",
    fieldType: "text",
    placeHolder: "terrence.rim@mail.com",
    automationId: "primaryEmail",
  },
  {
    fieldId: "phoneNumber",
    fieldLabel: "Phone Number",
    required: true,
    length: 2,
    validateType: "phone",
    validateIndex: 4,
    isValid: true,
    toolTipId: "phoneNumber",
    toolTipText: "Phone Number",
    fieldType: "text",
    placeHolder: "(123) 456-7890",
    automationId: "primaryPhoneNumber",
  },
  {
    fieldId: "extension",
    fieldLabel: "Extension",
    fieldType: "text",
    validateType: "extension",
    validateIndex: 5,
    length: 1,
    isValid: true,
    toolTipId: "primaryExtension",
    toolTipText: "Extension",
    placeHolder: "12345",
    automationId: "primaryExtension",
  },
  {
    fieldId: "sameContact",
    fieldLabel: "Your Primary contact is same for ",
    fieldType: "checkbox",
    fieldTechnical: "Technical/EDI",
    fieldCustomerService: "Customer Service",
    fieldShipping: "Shipping",
    automationId: "sameContact",
    validateIndex: 21,
  },
];

//TECHNICAL CONTACT FIELDS
export const TechnicalBasicContactFields = [
  {
    fieldId: "firstName",
    fieldLabel: "Technical/EDI Contact First Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 1,
    isValid: true,
    toolTipId: "ContactFirstName",
    toolTipText: "First Name",
    automationId: "technicalFirstName",
    placeHolder: "Terrence",
  },
  {
    fieldId: "lastName",
    fieldLabel: "Last Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 2,
    isValid: true,
    toolTipId: "lastName",
    toolTipText: "Last Name",
    placeHolder: "Buick",
    automationId: "technicalLastName",
  },
  {
    fieldId: "email",
    fieldLabel: "Email",
    required: true,
    length: 3,
    validateType: "email",
    validateIndex: 3,
    isValid: true,
    toolTipId: "email",
    toolTipText: "Email",
    fieldType: "text",
    placeHolder: "terrence.rim@mail.com",
    automationId: "technicalEmail",
  },
  {
    fieldId: "phoneNumber",
    fieldLabel: "Phone Number",
    required: true,
    length: 2,
    validateType: "phone",
    validateIndex: 4,
    isValid: true,
    toolTipId: "phoneNumber",
    toolTipText: "Phone Number",
    fieldType: "text",
    placeHolder: "(123) 456-7890",
    automationId: "technicalPhoneNumber",
  },
  {
    fieldId: "extension",
    fieldLabel: "Extension",
    fieldType: "text",
    validateType: "extension",
    validateIndex: 5,
    length: 1,
    isValid: true,
    toolTipId: "extension",
    toolTipText: "Extension",
    placeHolder: "12345",
    automationId: "technicalExtension",
  },
];

//CUSTOMER SERVICE CONTACT FIELDS
export const CustomerServiceContactFields = [
  {
    fieldId: "firstName",
    fieldLabel: "Customer Service Contact First Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 1,
    isValid: true,
    toolTipId: "ContactFirstName",
    toolTipText: "First Name",
    automationId: "customerserviceFirstName",
    placeHolder: "Terrence",
  },
  {
    fieldId: "lastName",
    fieldLabel: "Last Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 2,
    isValid: true,
    toolTipId: "lastName",
    toolTipText: "Last Name",
    placeHolder: "Buick",
    automationId: "customerserviceLastName",
  },
  {
    fieldId: "email",
    fieldLabel: "Email",
    required: true,
    length: 3,
    validateType: "email",
    validateIndex: 3,
    isValid: true,
    toolTipId: "email",
    toolTipText: "Email",
    fieldType: "text",
    placeHolder: "terrence.rim@mail.com",
    automationId: "customerserviceEmail",
  },
  {
    fieldId: "phoneNumber",
    fieldLabel: "Phone Number",
    required: true,
    length: 2,
    validateType: "phone",
    validateIndex: 4,
    isValid: true,
    toolTipId: "phoneNumber",
    toolTipText: "Phone Number",
    fieldType: "text",
    placeHolder: "(123) 456-7890",
    automationId: "customerservicePhoneNumber",
  },
  {
    fieldId: "extension",
    fieldLabel: "Extension",
    fieldType: "text",
    validateType: "extension",
    validateIndex: 5,
    length: 1,
    isValid: true,
    toolTipId: "extension",
    toolTipText: "Extension",
    placeHolder: "12345",
    automationId: "customerserviceExtension",
  },
];

//SHIPPING CONTACT FIELDS
export const ShippingContactFields = [
  {
    fieldId: "firstName",
    fieldLabel: "Shipping Contact First Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 1,
    isValid: true,
    toolTipId: "ContactFirstName",
    toolTipText: "First Name",
    automationId: "shippingFirstName",
    placeHolder: "Terrence",
  },
  {
    fieldId: "lastName",
    fieldLabel: "Last Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 2,
    isValid: true,
    toolTipId: "lastName",
    toolTipText: "Last Name",
    placeHolder: "Buick",
    automationId: "shippingLastName",
  },
  {
    fieldId: "email",
    fieldLabel: "Email",
    required: true,
    length: 3,
    validateType: "email",
    validateIndex: 3,
    isValid: true,
    toolTipId: "email",
    toolTipText: "Email",
    fieldType: "text",
    placeHolder: "terrence.rim@mail.com",
    automationId: "shippingEmail",
  },
  {
    fieldId: "phoneNumber",
    fieldLabel: "Phone Number",
    required: true,
    length: 2,
    validateType: "phone",
    validateIndex: 4,
    isValid: true,
    toolTipId: "phoneNumber",
    toolTipText: "Phone Number",
    fieldType: "text",
    placeHolder: "(123) 456-7890",
    automationId: "shippingPhoneNumber",
  },
  {
    fieldId: "extension",
    fieldLabel: "Extension",
    fieldType: "text",
    validateType: "extension",
    validateIndex: 5,
    length: 1,
    isValid: true,
    toolTipId: "extension",
    toolTipText: "Extension",
    placeHolder: "12345",
    automationId: "shippingExtension",
  },
];

// OTHER CONTACT FIELDS
export const OtherBasicContactFields = [
  {
    fieldId: "firstName",
    fieldLabel: "Other Contact First Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 1,
    isValid: true,
    toolTipId: "ContactFirstName",
    toolTipText: "First Name",
    automationId: "otherFirstName",
    placeHolder: "Terrence",
  },
  {
    fieldId: "lastName",
    fieldLabel: "Last Name",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "alphaNumSpaceSpecChar",
    validateIndex: 2,
    isValid: true,
    toolTipId: "lastName",
    toolTipText: "Last Name",
    placeHolder: "Buick",
    automationId: "otherLastName",
  },
  {
    fieldId: "email",
    fieldLabel: "Email",
    required: true,
    length: 3,
    validateType: "email",
    validateIndex: 3,
    isValid: true,
    toolTipId: "email",
    toolTipText: "Email",
    fieldType: "text",
    placeHolder: "terrence.rim@mail.com",
    automationId: "otherEmail",
  },
  {
    fieldId: "phoneNumber",
    fieldLabel: "Phone Number",
    required: true,
    length: 2,
    validateType: "phone",
    validateIndex: 4,
    isValid: true,
    toolTipId: "phoneNumber",
    toolTipText: "Phone Number",
    fieldType: "text",
    placeHolder: "(123) 456-7890",
    automationId: "otherPhoneNumber",
  },
  {
    fieldId: "extension",
    fieldLabel: "Extension",
    fieldType: "text",
    validateType: "extension",
    validateIndex: 5,
    length: 1,
    isValid: true,
    toolTipId: "extension",
    toolTipText: "Extension",
    placeHolder: "12345",
    automationId: "otherExtension",
  },
];

export const AddAnotherContact = {
  fieldId: "addAnotherContact",
  fieldLabel: "+ Add Other Contact",
  fieldType: "submit",
  automationId: "addAnotherContact",
};

export const ContactType = [
  {
    fieldId: "additionalJobRole",
    fieldLabel: "Contact Type",
    fieldType: "text",
    required: true,
    length: 3,
    validateType: "contactType",
    validateIndex: 6,
    isValid: true,
    toolTipId: "enterContactType",
    automationId: "otherEnterContactType",
    toolTipText: "Contact Type",
    placeHolder: "Enter Contact Type",
  },
];
